import React, { useState } from "react";
import bgImage from "./assets/bg.jpg";

import { useNavigate } from "react-router-dom";

export default function App() {
  const [showSignup, setShowSignup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [signupData, setSignupData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    permit: "yes",
  });

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const API_URL =
    process.env.REACT_APP_API_URL || "https://betking.waresford.com";
  const API_URLX = process.env.REACT_APP_API_URL || "http://localhost:1000";

  //HANDLERS--- MACDON CONSUMING ENDPOINTS
  const handleSignup = async () => {
    try {
      const res = await fetch(`${API_URL}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signupData),
      });

      const data = await res.json();
      alert(data.message);

      if (res.ok) setShowSignup(false);
    } catch (err) {
      alert("SignUp Failed");
    }
  };

  // Inside App component
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });

      const data = await res.json();

      if (!res.ok) return alert(data.message);

      alert("Login successful!");
      localStorage.setItem("token", data.token);
      localStorage.setItem("id", data.user.id);
      localStorage.setItem("name", data.user.name);
      localStorage.setItem("email", data.user.email);

      // redirect to dashboard
      //window.location.href = "/dashboard";
      // redirect to dashboard
      navigate("/dash");

      setShowLogin(false);
    } catch (err) {
      alert("Login failed");
    }
  };

  //END OF HANDLERS--- MACDON CONSUMING ENDPOINTS

  //CSS STYLING STARTS HERE

  const backdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const formStyle = {
    background: "white",
    padding: 36,
    borderRadius: 12,
    width: 480,
    maxWidth: "90%",
    position: "relative",
    boxShadow: "0 6px 30px rgba(0,0,0,0.25)",
  };

  const closeBtnStyle = {
    position: "absolute",
    top: 12,
    right: 12,
    fontSize: 22,
    lineHeight: 1,
    cursor: "pointer",
    border: "none",
    background: "transparent",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    marginBottom: 12,
    borderRadius: 8,
    border: "1px solid #ddd",
    boxSizing: "border-box",
    fontSize: 14,
  };

  const primaryBtn = {
    width: "100%",
    padding: "12px 14px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 15,
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        overflow: "hidden",
        fontFamily:
          "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      }}
    >
      {/* Top-right buttons */}
      <div
        style={{
          position: "absolute",
          top: 52,
          right: 35,
          display: "flex",
          gap: 12,
          zIndex: 20,
        }}
      >
        <button
          onClick={() => {
            setShowSignup(true);
            setShowLogin(false);
          }}
          style={{
            padding: "10px 18px",
            background: "rgba(255,255,255,0.95)",
            borderRadius: 10,
            border: "1px solid #e6e6e6",
            cursor: "pointer",
          }}
        >
          Sign Up
        </button>

        <button
          onClick={() => {
            setShowLogin(true);
            setShowSignup(false);
          }}
          style={{
            padding: "10px 18px",
            background: "rgba(255,255,255,0.95)",
            borderRadius: 10,
            border: "1px solid #e6e6e6",
            cursor: "pointer",
          }}
        >
          Login
        </button>
      </div>

      {/* Signup Modal */}
      {showSignup && (
        <div style={backdropStyle} onClick={() => setShowSignup(false)}>
          <div style={formStyle} onClick={(e) => e.stopPropagation()}>
            <button
              style={closeBtnStyle}
              aria-label="Close signup"
              onClick={() => setShowSignup(false)}
            >
              ×
            </button>
            <h2 style={{ margin: "0 0 18px", fontSize: 22 }}>
              Create an account
            </h2>

            <input
              style={inputStyle}
              placeholder="Full name"
              value={signupData.name}
              onChange={(e) =>
                setSignupData({ ...signupData, name: e.target.value })
              }
            />

            <input
              style={inputStyle}
              placeholder="Phone Number"
              value={signupData.phone}
              onChange={(e) =>
                setSignupData({ ...signupData, phone: e.target.value })
              }
            />

            <input
              style={inputStyle}
              placeholder="Email address"
              value={signupData.email}
              onChange={(e) =>
                setSignupData({ ...signupData, email: e.target.value })
              }
            />

            <input
              style={inputStyle}
              placeholder="Password"
              type="password"
              value={signupData.password}
              onChange={(e) =>
                setSignupData({ ...signupData, password: e.target.value })
              }
            />

            <button style={primaryBtn} onClick={handleSignup}>
              Create Account
            </button>
          </div>
        </div>
      )}

      {/* Login Modal */}
      {showLogin && (
        <div style={backdropStyle} onClick={() => setShowLogin(false)}>
          <div style={formStyle} onClick={(e) => e.stopPropagation()}>
            <button
              style={closeBtnStyle}
              aria-label="Close login"
              onClick={() => setShowLogin(false)}
            >
              ×
            </button>
            <h2 style={{ margin: "0 0 18px", fontSize: 22 }}>Welcome back</h2>
            <input
              style={inputStyle}
              placeholder="Email address"
              value={loginData.email}
              onChange={(e) =>
                setLoginData({ ...loginData, email: e.target.value })
              }
            />

            <input
              style={inputStyle}
              placeholder="Password"
              type="password"
              value={loginData.password}
              onChange={(e) =>
                setLoginData({ ...loginData, password: e.target.value })
              }
            />

            <button style={primaryBtn} onClick={handleLogin}>
              Login
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
